import { APIS,REPORT_DB_KEY } from "../../../../../utils/api-factory"
import { POST_HEADER, TENANT_HEADER } from '../../../../../utils/apiHeaders'
export const getOperationEmployee = (page, size, callBack) => {
    fetch(APIS.GET_OPERATIONS_EMPLOYEE + page + '&size=' + size)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataApi = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_PERFORMANCE_DATA_BY_EMAIL + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataGraphApi = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_OPETRATION_PERFORMANCE_API + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getSoftApprovalCommentsApi = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_SOFTAPPROVAL_API + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getProgressReportApi = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_SMALL_DASHBOARD_OPERATION_API + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getOperationTabularDataApi = (startDate, endDate, empId, process, callBack) => {
    fetch(APIS.OPERTAIONS_TABULAR_DATA_API + startDate + '&endDate=' + endDate + '&empId=' + empId + '&process=' + process)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}

export const downloadOperationData = (startDate, endDate, empId, process, callBack) => {
    fetch(APIS.DOWNLOAD_OPERATION_REPORT_API + startDate + '&endDate=' + endDate + '&empId=' + empId + '&process=' + process)
        .then(res => res.blob())
        .then(data => {
            var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
            var excelBlob = new Blob(
                [data],
                { type: 'application/vnd.ms-excel' },
                'excel.xls'
            )
            var link = window.URL.createObjectURL(excelBlob)
            window.location = link
            var downloadUrl = URL.createObjectURL(blob)
            var a = document.createElement('a')
            a.href = downloadUrl
            a.download = 'report.xls'
            document.body.appendChild(a)
            a.click()
            callBack(data)
        })
}




export const getCustomerServiceEmployee = (page, size, callBack) => {
    fetch(APIS.GET_CUSTOMER_SERVICE_EMPLOYEE + page + '&size=' + size)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataApiCustomerService = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_PERFORMANCE_DATA_BY_EMAIL_CUSTOMER_SERVICE + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataGraphApiCustomerService = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_CUSTOMER_SERVICE_PERFORMANCE_API + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getSoftApprovalCommentsApiCustomerService = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_SOFTAPPROVAL_API_CUSTOMER_SERVICE + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getProgressReportApiCustomerService = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_SMALL_DASHBOARD_OPERATION_API_CUSTOMER_SERVICE + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getOperationTabularDataApiCustomerService = (startDate, endDate, empId, process, callBack) => {
    fetch(APIS.OPERTAIONS_TABULAR_DATA_API_CUSTOMER_SERVICE + startDate + '&endDate=' + endDate + '&empId=' + empId + '&process=' + process)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}

export const downloadOperationDataCustomerService = (startDate, endDate, empId, process, callBack) => {
    fetch(APIS.DOWNLOAD_OPERATION_REPORT_API_CUSTOMER_SERVICE + startDate + '&endDate=' + endDate + '&empId=' + empId + '&process=' + process)
        .then(res => res.blob())
        .then(data => {
            var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
            var excelBlob = new Blob(
                [data],
                { type: 'application/vnd.ms-excel' },
                'excel.xls'
            )
            var link = window.URL.createObjectURL(excelBlob)
            window.location = link
            var downloadUrl = URL.createObjectURL(blob)
            var a = document.createElement('a')
            a.href = downloadUrl
            a.download = 'report.xls'
            document.body.appendChild(a)
            a.click()
            callBack(data)
        })
}




export const getRepeatFreshEmployee = (page, size, callBack) => {
    fetch(APIS.GET_REPEAT_FRESH_EMPLOYEE + page + '&size=' + size)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataApiRepeatFresh = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_PERFORMANCE_DATA_BY_EMAIL_REPEAT_FRESH + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataGraphApiRepeatFresh = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_REPEAT_FRESH_PERFORMANCE_API + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getSoftApprovalCommentsApiRepeatFresh = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_SOFTAPPROVAL_API_REPEAT_FRESH + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getProgressReportApiRepeatFresh = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_SMALL_DASHBOARD_OPERATION_API_REPEAT_FRESH + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getOperationTabularDataApiRepeatFresh = (startDate, endDate, empId, process, callBack) => {
    fetch(APIS.OPERTAIONS_TABULAR_DATA_API_REPEAT_FRESH + startDate + '&endDate=' + endDate + '&empId=' + empId + '&process=' + process)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}

export const downloadOperationDataRepeatFresh = (startDate, endDate, empId, process, callBack) => {
    fetch(APIS.DOWNLOAD_OPERATION_REPORT_API_REPEAT_FRESH + startDate + '&endDate=' + endDate + '&empId=' + empId + '&process=' + process)
        .then(res => res.blob())
        .then(data => {
            var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
            var excelBlob = new Blob(
                [data],
                { type: 'application/vnd.ms-excel' },
                'excel.xls'
            )
            var link = window.URL.createObjectURL(excelBlob)
            window.location = link
            var downloadUrl = URL.createObjectURL(blob)
            var a = document.createElement('a')
            a.href = downloadUrl
            a.download = 'report.xls'
            document.body.appendChild(a)
            a.click()
            callBack(data)
        })
}



export const getRepeatEmployee = (page, size, callBack) => {
    fetch(APIS.GET_REPEAT_EMPLOYEE + page + '&size=' + size)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataApiRepeat = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_PERFORMANCE_DATA_BY_EMAIL_REPEAT + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataGraphApiRepeat = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_REPEAT_PERFORMANCE_API + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getSoftApprovalCommentsApiRepeat = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_SOFTAPPROVAL_API_REPEAT + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getProgressReportApiRepeat = (startDate, endDate, empId, callBack) => {
    fetch(APIS.GET_SMALL_DASHBOARD_OPERATION_API_REPEAT + startDate + '&endDate=' + endDate + '&empId=' + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getOperationTabularDataApiRepeat = (startDate, endDate, empId, process, callBack) => {
    fetch(APIS.OPERTAIONS_TABULAR_DATA_API_REPEAT + startDate + '&endDate=' + endDate + '&empId=' + empId + '&process=' + process)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}

export const downloadOperationDataRepeat = (startDate, endDate, empId, process, callBack) => {
    fetch(APIS.DOWNLOAD_OPERATION_REPORT_API_REPEAT + startDate + '&endDate=' + endDate + '&empId=' + empId + '&process=' + process)
        .then(res => res.blob())
        .then(data => {
            var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
            var excelBlob = new Blob(
                [data],
                { type: 'application/vnd.ms-excel' },
                'excel.xls'
            )
            var link = window.URL.createObjectURL(excelBlob)
            window.location = link
            var downloadUrl = URL.createObjectURL(blob)
            var a = document.createElement('a')
            a.href = downloadUrl
            a.download = 'report.xls'
            document.body.appendChild(a)
            a.click()
            callBack(data)
        })
}

export const getPerformanceDataAPiNew = (empId, startDate, endDate, callBack) => {
    fetch(APIS.DATE_WISE_GRAPH_DATA + empId + '&sDate=' + startDate + '&eDate=' + endDate)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPerformanceDataAPiNewNew = (empId, startDate, endDate, callBack) => {
    fetch(APIS.DATE_WISE_GRAPH_DATA_NEW + empId + '&sDate=' + startDate + '&eDate=' + endDate)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getHourswiseDataApi = (empId, startDate, callBack) => {
    fetch(APIS.HOURS_WISE_DATA + empId + '&sDate=' + startDate)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getHourswiseDataNewApi = (empId, startDate, callBack) => {
    fetch(APIS.HOURS_WISE_DATA_NEW + empId + '&sDate=' + startDate)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getEmployeeLeadActivity = (data, callBack) => {

    fetch(APIS.GET_EMPLOYEE_LEAD_ACTIVITY, {
        method: 'POST',
        headers: POST_HEADER,
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}

export const getBusinessDevelopmentLeadProgressSummaryForEmployeeByDate = (start, end, empId, callBack) => {

    fetch(APIS.GET_BUSINESS_DEVELOPMENT_LEAD_PROGRESS_SUMMARY_FOR_EMPLOYEE_BY_DATE + start + "&eDate=" + end + "&assignedTo=" + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getBusinessDevelopmentLeadProgressDataForEmployeeByDate = (start, end, empId, filter, callBack) => {

    fetch(APIS.GET_BUSINESS_DEVELOPMENT_LEAD_PROGRESS_PROGRESS_DATA_FOR_EMPLOYEE_BY_DATE + start + "&eDate=" + end + "&assignedTo=" + empId + "&filterType=" + filter)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getLeadProgressSummaryForEmployeeById = (start, end, empId, callBack) => {

    fetch(APIS.GET_LEAD_PROGRESS_SUMMARY_FOR_EMPLOYEE_BY_ID + start + "&eDate=" + end + "&assignedTo=" + empId)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getLeadProgressDataForEmployeeById = (start, end, empId, filter, callBack) => {

    fetch(APIS.GET_LEAD_PROGRESS_DATA_FOR_EMPLOYEE_BY_ID + start + "&eDate=" + end + "&assignedTo=" + empId + "&filterType=" + filter)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}

//reporting apis for custom report
export const getMetaDataforcustomReport = (callBack) => {

    fetch(APIS.GET_META_DATA + REPORT_DB_KEY)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}

export const getPredefinedReportsforcustomReport = (callBack) => {

    fetch(APIS.GET_PREDEFINED_REPORTS + REPORT_DB_KEY)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPredefinedReportcolumnforcustomReportByReportId = (id, callBack) => {

    fetch(APIS.GET_PREDEFINED_REPORT_COLUMN_BY_REPORTID + REPORT_DB_KEY + "&report_id=" + id)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getPreviewReportByParams = (params,dates, callBack) => {

    fetch(APIS.GET_PREVIEW_REPORT_BY_PARAMS + REPORT_DB_KEY + "&"  + params + "&start_date=" + dates?.mongo_start_date + "&end_date=" + dates?.mongo_end_date)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getDistinctValuesForTablByTablecolumn = (table,column, callBack) => {

    fetch(APIS.GET_DISTINCT_VALUES_FOR_TABLE_BY_TABLE_AND_COLUMN + REPORT_DB_KEY + "&table=" + table + "&column=" + column )
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getOperationLeadProgressSummaryForEmployeeByDate = (start,end, id, callBack) => {

    fetch(APIS.GET_OPERATIONS_LEAD_PROGRESS_SUMMARY_FOR_EMPLOYEE + start + "&eDate=" + end + "&assignedTo=" + id )
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const getOperationLeadProgressDataForEmployeeByDate = (start,end, id,filterType, callBack) => {

    fetch(APIS.GET_OPERATIONS_LEAD_PROGRESS_DATA_FOR_EMPLOYEE + start + "&eDate=" + end + "&assignedTo=" + id + "&filterType=" + filterType)
        .then(res => res.json())
        .then(json => {
            callBack(json)
        })
        .catch(err => {
            callBack(null)
        })
}
export const DownloadPreviewReportByParams = (params,dates,filenames, callBack) => {
    
    fetch(APIS.DOWNLOAD_PREVIEW_REPORT_BY_PARAMS + REPORT_DB_KEY + "&" + params + "&start_date=" + dates?.mongo_start_date + "&end_date=" + dates?.mongo_end_date)
    .then(res => {
        if (!res.ok) {
            throw new Error('Network response was not ok');
        }

        
        const contentDisposition = res.headers.get('Content-Disposition');
        let filename = `${filenames}.csv`;
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }

        return res.blob().then(blob => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        callBack(true); 
    })
    .catch(err => {
        console.error('Download failed:', err);
        callBack(null);
    });

}


// new generate report apis 

export const uploadCsvApi = async (file, sessionId = "",id) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("session_id", sessionId);
    formData.append("user_id", id);

    const res = await fetch(APIS.UPLOAD_CSV, {
      method: "POST",
      body: formData,
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "CSV upload failed");
    }

    const data = await res.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.error("uploadCsvApi error:", error);
    throw error;
  }
};

export const askAiApi = (question, sessionId,id) => {
  const body = {
    session_id: sessionId,
    query: question,
    user_id: id,
  };

  return fetch(APIS.ASK_AI, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(body),
  }).then((response) => {
    if (!response.body) {
      throw new Error("Streaming not supported");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    return {
      async *[Symbol.asyncIterator]() {
        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;

          const lines = buffer.split("\n");
          buffer = lines.pop();

          for (const line of lines) {
            if (!line.trim()) continue;

            try {
              yield JSON.parse(line);
            } catch (err) {
              console.log("Invalid JSON:", line);
            }
          }
        }

        if (buffer.trim()) {
          try {
            yield JSON.parse(buffer);
          } catch (err) {}
        }
      },
    };
  });
};

export const getSessionsApi = async (id) => {
  try {
    const url = `${APIS.GET_SESSIONS}${id}`;

    const res = await fetch(url, {
      headers: { accept: "application/json" },
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    const data = await res.json();

    if (Array.isArray(data.sessions)) {
      data.sessions.sort(
        (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
      );
    }

    return data;
  } catch (error) {
    console.error("getSessionsApi error:", error);
    throw error;
  }
};

export const getConversationByIdApi = async (sessionId, userId) => {
  try {
    const url = `${APIS.GET_CONVERSATION}${sessionId}?user_id=${userId}`;

    const res = await fetch(url, {
      headers: { accept: "application/json" },
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return await res.json();
  } catch (error) {
    console.error("getConversationByIdApi error:", error);
    throw error;
  }
};

export const uploadCsvByUrlApi = async (csvUrl, sessionId = "" , userId) => {
  try {
    const body = {
      csv_url: csvUrl,
      session_id: sessionId,
      user_id: userId,
    };

    const res = await fetch(APIS.UPLOAD_CSV_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "CSV URL upload failed");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("uploadCsvByUrlApi error:", error);
    throw error;
  }
};